import { stages } from '~/lib/salesPipeline';

const stageKeys = stages.map((stage) => stage.key);

export const StageListSkeleton = () => {
  return (
    <div className="flex items-center justify-between space-x-2">
      {stageKeys.map((_, index) => {
        return (
          <div key={index} className="flex flex-1">
            <div className="flex flex-1 h-20 ck-skeleton"></div>
          </div>
        );
      })}
    </div>
  );
};
